import { removeParentNodeOfType } from 'prosemirror-utils';
import { TableNode } from './const';
import { isIntoTable } from './helpers';
const mdTamplate = `

| Heading | Heading |
| ------- | ------- |
| Text    | Text    |
| Text    | Text    |

`.trim();
const createTableFactory = (parser) => (state, dispatch) => {
    if (isIntoTable(state)) {
        return false;
    }
    if (dispatch) {
        const node = parser.parse(mdTamplate);
        dispatch(state.tr.replaceSelectionWith(node).scrollIntoView());
    }
    return true;
};
const removeTable = (state, dispatch) => {
    if (isIntoTable(state)) {
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(removeParentNodeOfType(state.schema.nodes[TableNode.Table])(state.tr));
        return true;
    }
    return false;
};
export const createTableAction = ({ parser }) => ({
    isActive: isIntoTable,
    isEnable: createTableFactory(parser),
    run: createTableFactory(parser),
});
export const deleteTableAction = {
    isEnable: removeTable,
    run: removeTable,
};
